// ID: 1 TO 120

const MensWear =
{
  ApiCategory: "MensWear",
  MensTopData: [
    {
      id: 1,
      brand: "Shopster",
      name: "Men Slim Fit Printed Spread Collar Casual Shirt",
      main_img:
        "https://i.postimg.cc/VLN7bpgc/1-1.jpg",
      item_img_1:
        "https://i.postimg.cc/FK0G44r0/1-2.jpg",
      item_img_2:
        "https://i.postimg.cc/tCmBdkvn/1-3.jpg",
      item_img_3:
        "https://i.postimg.cc/BnrNk60q/1-4.jpg",
      item_img_4:
        "https://i.postimg.cc/3x4ntGzS/1-5.jpg",
      price: 461,
      old_price: "₹1399",
      price_off: "67% Off",
      category: "Shirt",
      rating: 2.9,
      // qty: 1,

    },
    {
      id: 2,
      brand: "Shopster",
      name: "Men Slim Fit Checkered Button Down Collar Casual Shirt",
      main_img:
        "https://i.postimg.cc/m2wtK6Wh/2-1.jpg",
      item_img_1:
        "https://i.postimg.cc/cLLrWMdh/2-2.jpg",
      item_img_2:
        "https://i.postimg.cc/WbjdWcKQ/2-3.jpg",
      item_img_3:
        "https://i.postimg.cc/prQpWs9G/2-4.jpg",
      item_img_4:
        "https://i.postimg.cc/h4VJ1tCL/2-5.jpg",
      price: 1266,
      old_price: "₹2390",
      price_off: "47% Off",
      category: "Shirt",
      rating: 3.9,
      qty: 1,
    },
    {
      id: 3,
      brand: "Shopster",
      name: "Men Slim Fit Solid Mandarin Collar Casual Shirt",
      main_img:
        "https://i.postimg.cc/Z5wjYcp5/3-1.jpg",
      item_img_1:
        "https://i.postimg.cc/hPbp6gGx/3-2.jpg",
      item_img_2:
        "https://i.postimg.cc/XvXLrCkc/3-3.jpg",
      item_img_3:
        "https://i.postimg.cc/QMPb1d6L/3-4.jpg",
      item_img_4:
        "https://i.postimg.cc/wjq0dPtr/3-5.jpg",
      price: 445,
      old_price: "₹1649",
      price_off: "73% Off",
      category: "Shirt",
      rating: 2.9,
      qty: 1,
    },
    {
      id: 4,
      brand: "Shopster",
      name: "Men Slim Fit Solid Cut Away Collar Casual Shirt",
      main_img:
        "https://i.postimg.cc/7Lvhzvgs/4-1.jpg",
      item_img_1:
        "https://i.postimg.cc/fybRsMNL/4-2.jpg",
      item_img_2:
        "https://i.postimg.cc/nVdLk94Q/4-3.jpg",
      item_img_3:
        "https://i.postimg.cc/8cnPPxpb/4-4.jpg",
      item_img_4:
        "https://i.postimg.cc/DzqZdC62/4-5.jpg",
      price: 420,
      old_price: "₹1399",
      price_off: "96% Off",
      category: "Shirt",
      rating: 3.9,
      qty: 1,

    },
    {
      id: 5,
      brand: "Shopster",
      name: "Men Slim Fit Solid Cut Away Collar Casual Shirt",
      main_img:
        "https://i.postimg.cc/4xHnn4hH/5-1.jpg",
      item_img_1:
        "https://i.postimg.cc/KzxY9npt/5-2.jpg",
      item_img_2:
        "https://i.postimg.cc/SsdxHJH3/5-3.jpg",
      item_img_3:
        "https://i.postimg.cc/8Pjznk4X/5-4.jpg",
      item_img_4:
        "https://i.postimg.cc/GhVm00SL/5-5.jpg",
      price: 412,
      old_price: "₹1649",
      price_off: "75% Off",
      category: "Shirt",
      rating: 2.9,
      qty: 1,
    },
    {
      id: 6,
      brand: "Shopster",
      name: "Men Slim Fit Printed Spread Collar Casual Shirt",
      main_img:
        "https://i.postimg.cc/RZtV4Pjc/6-1.jpg",
      item_img_1:
        "https://i.postimg.cc/25fj6QDg/6-2.jpg",
      item_img_2:
        "https://i.postimg.cc/HL4Y7rWn/6-3.jpg",
      item_img_3:
        "https://i.postimg.cc/pTW2QPyZ/6-4.jpg",
      item_img_4:
        "https://i.postimg.cc/fL8MB19h/6-5.jpg",
      price: 461,
      old_price: "₹1399",
      price_off: "67% Off",
      category: "Shirt",
      rating: 3.9,
      qty: 1,
    },

    {
      id: 7,
      brand: "Shopster",
      name: "Westside White Printed Relaxed Fit Shirt",
      main_img:
        "https://img.tatacliq.com/images/i14/437Wx649H/MP000000019563746_437Wx649H_202310081148081.jpeg",
      item_img_1:
        "https://img.tatacliq.com/images/i14/437Wx649H/MP000000019563746_437Wx649H_202310081148102.jpeg",
      item_img_2:
        "https://img.tatacliq.com/images/i14/437Wx649H/MP000000019563746_437Wx649H_202310081148073.jpeg",
      item_img_3:
        "https://img.tatacliq.com/images/i14/437Wx649H/MP000000019563746_437Wx649H_202310081148114.jpeg",
      item_img_4:
        "https://img.tatacliq.com/images/i14/437Wx649H/MP000000019563746_437Wx649H_202310081148081.jpeg",
      price: 999,
      old_price: "₹1599",
      Stock: "Limited Stock!",
      price_off: "80% Off",
      category: "Shirt",
      rating: 2.9,
      qty: 1,
    },
    {
      id: 8,
      brand: "Shopster",
      name: " Light Yellow Fit Cotton Shirt",
      main_img:
        "https://img.tatacliq.com/images/i10/437Wx649H/MP000000016854348_437Wx649H_202303151458131.jpeg",
      item_img_1:
        "https://img.tatacliq.com/images/i10/437Wx649H/MP000000016854348_437Wx649H_202303151458152.jpeg",
      item_img_2:
        "https://img.tatacliq.com/images/i10/437Wx649H/MP000000016854348_437Wx649H_202303151458173.jpeg",
      item_img_3:
        "https://img.tatacliq.com/images/i10/437Wx649H/MP000000016854348_437Wx649H_202303151458194.jpeg",
      item_img_4:
        "https://img.tatacliq.com/images/i10/437Wx649H/MP000000016854348_437Wx649H_202303151458115.jpeg",
      price: 679,
      old_price: "₹3399",
      price_off: "80% Off",
      category: "Shirt",
      rating: 2.9,
      qty: 1,
    },
    {
      id: 9,
      brand: "Shopster",
      name: "Men Slim Fit Solid Mandarin Collar Casual Shirt",
      main_img:
        "https://i.postimg.cc/j5BnMWNT/7-1.jpg",
      item_img_1:
        "https://i.postimg.cc/T3cmT38j/7-2.jpg",
      item_img_2:
        "https://i.postimg.cc/pdGFncLp/7-3.jpg",
      item_img_3:
        "https://i.postimg.cc/Hsw8tkLG/7-4.jpg",
      item_img_4:
        "https://i.postimg.cc/8PQrW6NB/7-5.jpg",
      price: 445,
      old_price: "₹1649",
      price_off: "73% Off",
      category: "Shirt",
      rating: 3.2,
      qty: 1,
    },

    {
      id: 10,
      brand: "Shopster",
      name: " Navy Regular Fit Cotton Shirt",
      main_img:
        "https://img.tatacliq.com/images/i9/437Wx649H/MP000000016361187_437Wx649H_202302032329031.jpeg",
      item_img_1:
        "https://img.tatacliq.com/images/i9/437Wx649H/MP000000016361187_437Wx649H_202302032329012.jpeg",
      item_img_2:
        "https://img.tatacliq.com/images/i9/437Wx649H/MP000000016361187_437Wx649H_202302032328593.jpeg",
      item_img_3:
        "https://img.tatacliq.com/images/i9/437Wx649H/MP000000016361187_437Wx649H_202302032329024.jpeg",
      item_img_4:
        "https://img.tatacliq.com/images/i9/437Wx649H/MP000000016361187_437Wx649H_202302032329065.jpeg",
      price: 679,
      old_price: "₹3399",
      price_off: "80% Off",
      category: "Shirt",
      rating: 2.9,
      qty: 1,
    },
    {
      id: 11,
      brand: "Shopster",
      name: "Casuals by Westside White Shirt",
      main_img:
        "https://img.tatacliq.com/images/i10/437Wx649H/MP000000016854606_437Wx649H_202303151508201.jpeg",
      item_img_1:
        "https://img.tatacliq.com/images/i10/437Wx649H/MP000000016854606_437Wx649H_202303151508222.jpeg",
      item_img_2:
        "https://img.tatacliq.com/images/i10/437Wx649H/MP000000016854606_437Wx649H_202303151508343.jpeg",
      item_img_3:
        "https://img.tatacliq.com/images/i10/437Wx649H/MP000000016854606_437Wx649H_202303151508364.jpeg",
      item_img_4:
        "https://img.tatacliq.com/images/i10/437Wx649H/MP000000016854606_437Wx649H_202303151508325.jpeg",
      price: 1299,
      old_price: "₹899",
      Stock: "Limited Stock!!",
      price_off: "80% Off",
      category: "Shirt",
      rating: 2.9,
      qty: 1,
    },
    {
      id: 12,
      brand: "Shopster",
      name: "Men Slim Fit Solid Cut Away Collar Casual Shirt",
      main_img:
        "https://i.postimg.cc/CMfqzNTx/8-1.jpg",
      item_img_1:
        "https://i.postimg.cc/d1hTRRhn/8-2.jpg",
      item_img_2:
        "https://i.postimg.cc/fyXtpwj9/8-3.jpg",
      item_img_3:
        "https://i.postimg.cc/BvVjv8mF/8-4.jpg",
      item_img_4:
        "https://i.postimg.cc/CK1ZYCsY/8-5.jpg",
      price: 531,
      old_price: "₹1899",
      price_off: "72% Off",
      category: "Shirt",
      rating: 3.7,
      qty: 1,
    },

    {
      id: 13,
      brand: "Shopster",
      name: "Men Regular Fit Printed Mandarin Collar Casual Shirt",
      main_img:
        "https://i.postimg.cc/qBYWGp5G/9-1.jpg",
      item_img_1:
        "https://i.postimg.cc/dVRXvrtW/9-2jpg",
      item_img_2:
        "https://i.postimg.cc/nhf560Zj/9-3.jpg",
      item_img_3:
        "https://i.postimg.cc/N0gn0FKQ/9-4.jpg",
      item_img_4:
        "https://i.postimg.cc/sDhq6tFC/9-5.jpg",
      price: 639,
      old_price: "₹1599",
      price_off: "60% Off",
      category: "Shirt",
      rating: 3.9,
      qty: 1,
    },
    {
      id: 14,
      brand: "Shopster",
      name: " White Cotton Slim Fit Printed Shirt",
      main_img:
        "https://img.tatacliq.com/images/i8/437Wx649H/MP000000013801964_437Wx649H_202207160616231.jpeg",
      item_img_1:
        "https://img.tatacliq.com/images/i8/437Wx649H/MP000000013801964_437Wx649H_202207160616252.jpeg",
      item_img_2:
        "https://img.tatacliq.com/images/i8/437Wx649H/MP000000013801964_437Wx649H_202207160616263.jpeg",
      item_img_3:
        "https://img.tatacliq.com/images/i8/437Wx649H/MP000000013801964_437Wx649H_202207160616284.jpeg",
      item_img_4:
        "https://img.tatacliq.com/images/i8/437Wx649H/MP000000013801964_437Wx649H_202207160616295.jpeg",
      price: 679,
      old_price: "₹3399",
      price_off: "80% Off",
      category: "Shirt",
      rating: 2.9,
      qty: 1,
    },
    {
      id: 15,
      brand: "Shopster",
      name: " Benetton Blue Linen Slim Fit Shirt",
      main_img:
        "https://img.tatacliq.com/images/i11/437Wx649H/MP000000017999211_437Wx649H_202306171934201.jpeg",
      item_img_1:
        "https://img.tatacliq.com/images/i11/437Wx649H/MP000000017999211_437Wx649H_202306171934172.jpeg",
      item_img_2:
        "https://img.tatacliq.com/images/i11/437Wx649H/MP000000017999211_437Wx649H_202306171934183.jpeg",
      item_img_3:
        "https://img.tatacliq.com/images/i11/437Wx649H/MP000000017999211_437Wx649H_202306171934224.jpeg",
      item_img_4:
        "https://img.tatacliq.com/images/i11/437Wx649H/MP000000017999211_437Wx649H_202306171934235.jpeg",
      price: 1859,
      old_price: "₹2999",
      price_off: "38% Off",
      category: "Shirt",
      rating: 2.9,
      qty: 1,
    },
    {
      id: 16,
      brand: "Shopster",
      name: "Arrow Rust Cotton Slim Fit Checks Shirt",
      main_img:
        "https://img.tatacliq.com/images/i9/437Wx649H/MP000000016521121_437Wx649H_202302141654551.jpeg",
      item_img_1:
        "https://img.tatacliq.com/images/i9/437Wx649H/MP000000016521121_437Wx649H_202302141654492.jpeg",
      item_img_2:
        "https://img.tatacliq.com/images/i9/437Wx649H/MP000000016521121_437Wx649H_202302141654523.jpeg",
      item_img_3:
        "https://img.tatacliq.com/images/i9/437Wx649H/MP000000016521121_437Wx649H_202302141654504.jpeg",
      item_img_4:
        "https://img.tatacliq.com/images/i9/437Wx649H/MP000000016521121_437Wx649H_202302141654575.jpeg",
      price: 1428,
      old_price: "₹2599",
      price_off: "45% Off",
      category: "Shirt",
      rating: 2.9,
      qty: 1,
    },
    {
      id: 17,
      brand: "Shopster",
      name: "Allen Solly White Linen Slim Fit Shirt",
      main_img:
        "https://img.tatacliq.com/images/i12/437Wx649H/MP000000018435761_437Wx649H_202307231752221.jpeg",
      item_img_1:
        "https://img.tatacliq.com/images/i12/437Wx649H/MP000000018435761_437Wx649H_202307231752232.jpeg",
      item_img_2:
        "https://img.tatacliq.com/images/i12/437Wx649H/MP000000018435761_437Wx649H_202307231752243.jpeg",
      item_img_3:
        "https://img.tatacliq.com/images/i12/437Wx649H/MP000000018435761_437Wx649H_202307231752254.jpeg",
      item_img_4:
        "https://img.tatacliq.com/images/i12/437Wx649H/MP000000018435761_437Wx649H_202307231752215.jpeg",
      price: 3044,
      old_price: "₹3499",
      price_off: "13% Off",
      category: "Shirt",
      rating: 2.9,
      qty: 1,
    },
    {
      id: 18,
      brand: "Shopster",
      name: "Men Slim Fit Solid Cut Away Collar Casual Shirt",
      main_img:
        "https://i.postimg.cc/1t722S5s/10-1.jpg",
      item_img_1:
        "https://i.postimg.cc/Fz2qFxL6/10-2.jpg",
      item_img_2:
        "https://i.postimg.cc/KjKwyWRL/10-3.jpg",
      item_img_3:
        "https://i.postimg.cc/G2tSkfPN/10-4.jpg",
      item_img_4:
        "https://i.postimg.cc/k5fpRCSK/10-5.jpg",
      price: 495,
      old_price: "₹1649",
      price_off: "69% Off",
      category: "Shirt",
      rating: 3.4,
      qty: 1,
    },
    {
      id: 19,
      brand: "Shopster",
      name: "Being Human Black Slim Fit Shirt",
      main_img:
        "https://img.tatacliq.com/images/i10/437Wx649H/MP000000016907311_437Wx649H_202303181804201.jpeg",
      item_img_1:
        "https://img.tatacliq.com/images/i10/437Wx649H/MP000000016907311_437Wx649H_202303181804132.jpeg",
      item_img_2:
        "https://img.tatacliq.com/images/i10/437Wx649H/MP000000016907311_437Wx649H_202303181804103.jpeg",
      item_img_3:
        "https://img.tatacliq.com/images/i10/437Wx649H/MP000000016907311_437Wx649H_202303181804084.jpeg",
      item_img_4:
        "https://img.tatacliq.com/images/i10/437Wx649H/MP000000016907311_437Wx649H_202303181804165.jpeg",
      price: 895,
      old_price: "₹2799",
      price_off: "68% Off",
      category: "Shirt",
      rating: 2.9,
      qty: 1,
    },
    {
      id: 20,
      brand: "Shopster",
      name: " Multicolor Slim Striped Cotton Shirt",
      main_img:
        "https://img.tatacliq.com/images/i10/437Wx649H/MP000000017193988_437Wx649H_202304132040141.jpeg",
      item_img_1:
        "https://img.tatacliq.com/images/i10/437Wx649H/MP000000017193988_437Wx649H_202304132040122.jpeg",
      item_img_2:
        "https://img.tatacliq.com/images/i10/437Wx649H/MP000000017193988_437Wx649H_202304132040153.jpeg",
      item_img_3:
        "https://img.tatacliq.com/images/i10/437Wx649H/MP000000017193988_437Wx649H_202304132040174.jpeg",
      item_img_4:
        "https://img.tatacliq.com/images/i10/437Wx649H/MP000000017193988_437Wx649H_202304132040115.jpeg",
      price: 1996,
      old_price: "₹2495",
      price_off: "20% Off",
      category: "Shirt",
      rating: 2.9,
      qty: 1,
    },

    {
      id: 21,
      brand: "Shopster",
      name: "Maroon Cotton Regular Fit Checks Shirt",
      main_img:
        "https://img.tatacliq.com/images/i14/437Wx649H/MP000000019971943_437Wx649H_202311072351031.jpeg",
      item_img_1:
        "https://img.tatacliq.com/images/i14/437Wx649H/MP000000019971943_437Wx649H_202311072351052.jpeg",
      item_img_2:
        "https://img.tatacliq.com/images/i14/437Wx649H/MP000000019971943_437Wx649H_202311072351063.jpeg",
      item_img_3:
        "https://img.tatacliq.com/images/i14/437Wx649H/MP000000019971943_437Wx649H_202311072351014.jpeg",
      item_img_4:
        "https://img.tatacliq.com/images/i14/437Wx649H/MP000000019971943_437Wx649H_202311072351085.jpeg",
      price: 1999,
      old_price: "₹2495",
      price_off: "60% Off",
      category: "Shirt",
      rating: 2.9,
      qty: 1,
    },
    {
      id: 22,
      brand: "Shopster",
      name: " Blue Cotton Regular Fit Shirt",
      main_img:
        "https://img.tatacliq.com/images/i14/437Wx649H/MP000000019972189_437Wx649H_202311080001091.jpeg",
      item_img_1:
        "https://img.tatacliq.com/images/i14/437Wx649H/MP000000019972189_437Wx649H_202311080001102.jpeg",
      item_img_2:
        "https://img.tatacliq.com/images/i14/437Wx649H/MP000000019972189_437Wx649H_202311080001123.jpeg",
      item_img_3:
        "https://img.tatacliq.com/images/i14/437Wx649H/MP000000019972189_437Wx649H_202311080001074.jpeg",
      item_img_4:
        "https://img.tatacliq.com/images/i14/437Wx649H/MP000000019972189_437Wx649H_202311080001135.jpeg",
      price: 999,
      old_price: "₹2495",
      price_off: "80% Off",
      category: "Shirt",
      rating: 2.9,
      qty: 1,
    },
    {
      id: 23,
      brand: "Shopster",
      name: "Men Slim Fit Printed Spread Collar Casual Shirt",
      main_img:
        "https://i.postimg.cc/MZ7j7mtZ/11-1.jpg",
      item_img_1:
        "https://i.postimg.cc/3NF433W0/11-2.jpg",
      item_img_2:
        "https://i.postimg.cc/wTFyPxSS/11-3.jpg",
      item_img_3:
        "https://i.postimg.cc/W4qdhGhv/11-4.jpg",
      item_img_4:
        "https://i.postimg.cc/26pVv1ZB/11-5.jpg",
      price: 405,
      old_price: "₹1349",
      price_off: "69% Off",
      category: "Shirt",
      rating: 4,
      qty: 1,
    },
    {
      id: 24,
      brand: "Shopster",
      name: " SHOWOFF Navy Blue Slim Fit Checks Shirt",
      main_img:
        "https://img.tatacliq.com/images/i14/437Wx649H/MP000000019827161_437Wx649H_202310271648411.jpeg",
      item_img_1:
        "https://img.tatacliq.com/images/i14/437Wx649H/MP000000019827161_437Wx649H_202310271648392.jpeg",
      item_img_2:
        "https://img.tatacliq.com/images/i14/437Wx649H/MP000000019827161_437Wx649H_202310271648423.jpeg",
      item_img_3:
        "https://img.tatacliq.com/images/i14/437Wx649H/MP000000019827161_437Wx649H_202310271648454.jpeg",
      item_img_4:
        "https://img.tatacliq.com/images/i14/437Wx649H/MP000000019827161_437Wx649H_202310271648385.jpeg",
      price: 952,
      old_price: "₹2380",
      price_off: "60% Off",
      category: "Shirt",
      rating: 2.9,
      qty: 1,
    },
    {
      id: 25,
      brand: "Shopster",
      name: "Dark Green Regular Fit Shirt",
      main_img:
        "https://img.tatacliq.com/images/i8/437Wx649H/MP000000015191655_437Wx649H_202211060047171.jpeg",
      item_img_1:
        "https://img.tatacliq.com/images/i8/437Wx649H/MP000000015191655_437Wx649H_202211060047122.jpeg",
      item_img_2:
        "https://img.tatacliq.com/images/i8/437Wx649H/MP000000015191655_437Wx649H_202211060047093.jpeg",
      item_img_3:
        "https://img.tatacliq.com/images/i8/437Wx649H/MP000000015191655_437Wx649H_202211060047144.jpeg",
      item_img_4:
        "https://img.tatacliq.com/images/i8/437Wx649H/MP000000015191655_437Wx649H_202211060047195.jpeg",
      price: 759,
      old_price: "₹1599",
      price_off: "60% Off",
      category: "Shirt",
      rating: 2.9,
      qty: 1,
    },
    {
      id: 26,
      brand: "Shopster",
      name: "Levi's Blue Relaxed Fit Floral Print Shirt",
      main_img:
        "https://img.tatacliq.com/images/i13/437Wx649H/MP000000019345428_437Wx649H_202309221412141.jpeg",
      item_img_1:
        "https://img.tatacliq.com/images/i13/437Wx649H/MP000000019345428_437Wx649H_202309221412112.jpeg",
      item_img_2:
        "https://img.tatacliq.com/images/i13/437Wx649H/MP000000019345428_437Wx649H_202309221412133.jpeg",
      item_img_3:
        "https://img.tatacliq.com/images/i13/437Wx649H/MP000000019345428_437Wx649H_202309221412164.jpeg",
      item_img_4:
        "https://img.tatacliq.com/images/i13/437Wx649H/MP000000019345428_437Wx649H_202309221412155.jpeg",
      price: 2319,
      old_price: "₹2899",
      price_off: "20% Off",
      category: "Shirt",
      rating: 2.9,
      qty: 1,
    },
    {
      id: 27,
      brand: "Shopster",
      name: "Men Slim Fit Printed Spread Collar Casual Shirt",
      main_img:
        "https://i.postimg.cc/ncn909w4/12-1.jpg",
      item_img_1:
        "https://i.postimg.cc/dV1kKPFD/12-2.jpg",
      item_img_2:
        "https://i.postimg.cc/kgpVJ1Ms/12-3.jpg",
      item_img_3:
        "https://i.postimg.cc/jdqCz0Lv/12-4.jpg",
      item_img_4:
        "https://i.postimg.cc/J0xn9Kdb/12-5.jpg",
      price: 439,
      old_price: "₹1399",
      price_off: "68% Off",
      category: "Shirt",
      rating: 2.9,
      qty: 1,
    },
    {
      id: 28,
      brand: "Shopster",
      name: " KINGSMAN Aqua Regular Fit Linen Shirt",
      main_img:
        "https://img.tatacliq.com/images/i9/437Wx649H/MP000000016551529_437Wx649H_202302161544161.jpeg",
      item_img_1:
        "https://img.tatacliq.com/images/i9/437Wx649H/MP000000016551529_437Wx649H_202302161543532.jpeg",
      item_img_2:
        "https://img.tatacliq.com/images/i9/437Wx649H/MP000000016551529_437Wx649H_202302161543503.jpeg",
      item_img_3:
        "https://img.tatacliq.com/images/i9/437Wx649H/MP000000016551529_437Wx649H_202302161543564.jpeg",
      item_img_4:
        "https://img.tatacliq.com/images/i9/437Wx649H/MP000000016551529_437Wx649H_202302161544125.jpeg",
      price: 679,
      old_price: "₹3399",
      price_off: "80% Off",
      category: "Shirt",
      rating: 2.9,
      qty: 1,
    },
    {
      id: 29,
      brand: "Shopster",
      name: "Men Checkered Casual Shirt",
      main_img:
        "https://i.postimg.cc/15MXQdDr/5.jpg",
      item_img_1:
        "https://i.postimg.cc/V6yLgPcm/4.jpg",
      item_img_2:
        "https://i.postimg.cc/W133b7nL/3.jpg",
      item_img_3:
        "https://i.postimg.cc/R0JZwVyg/1.jpg",
      item_img_4:
        "https://i.postimg.cc/x14dkbxk/2.jpg",
      price: 661,
      old_price: "₹1499",
      price_off: "55% Off",
      category: "Shirt",
      rating: 3.9,
      qty: 1,
    },
    {
      id: 30,
      brand: "Shopster",
      name: "Men Slim Fit Solid Spread Collar Casual Shirt",
      main_img:
        "https://i.postimg.cc/kMvB6XXB/13-1.jpg",
      item_img_1:
        "https://i.postimg.cc/zGVBcCwg/13-2.jpg",
      item_img_2:
        "https://i.postimg.cc/SNZRdT94/13-3.jpg",
      item_img_3:
        "https://i.postimg.cc/90C08s1m/13-4.jpg",
      item_img_4:
        "https://i.postimg.cc/jSm50Dvk/13-5.jpg",
      price: 469,
      old_price: "₹1849",
      price_off: "773% Off",
      category: "Shirt",
      rating: 3.9,
      qty: 1,
    },
  ],

  MensBottomData : [
    {
      id: 31,
      brand: "Shopster",
      name: "Men Tapered White Pure Cotton Trousers",
      main_img:
        "https://i.postimg.cc/GmbPLgtR/J1-1.jpg",
      item_img_1:
        "https://i.postimg.cc/MZR1yJjx/J1-2.jpg",
      item_img_2:
        "https://i.postimg.cc/X7bdL1w5/J1-3.jpg",
      item_img_3:
        "https://i.postimg.cc/jd4NF6XF/J1-4.jpg",
      item_img_4:
        "https://i.postimg.cc/x1jHDkpT/J1-5.jpg",
      price: 1095,
      old_price: "₹1799",
      price_off: "38% Off",
      category: "Trousers",
      rating: 4.9,
      // qty: 1,

    },
    {
      id: 32,
      brand: "Shopster",
      name: "Men Regular Fit Grey Cotton Blend Trousers",
      main_img:
        "https://i.postimg.cc/52PzxxD5/J2-1.jpg",
      item_img_1:
        "https://i.postimg.cc/R0NHhkzk/J2-2.jpg",
      item_img_2:
        "https://i.postimg.cc/26WLFnyT/J2-3.jpg",
      item_img_3:
        "https://i.postimg.cc/WzPF9tJV/J2-4.jpg",
      item_img_4:
        "https://i.postimg.cc/Dzycgp36/J2-5.jpg",
      price: 702,
      old_price: "₹1799",
      price_off: "60% Off",
      category: "Trousers",
      rating: 3.9,
      // qty: 1,
    },
    {
      id: 33,
      brand: "Shopster",
      name: "Men Regular Mid Rise Blue Jeans",
      main_img:
        "https://i.postimg.cc/HsD4KkCV/J3-1.jpg",
      item_img_1:
        "https://i.postimg.cc/SN67pbyV/J3-2.jpg",
      item_img_2:
        "https://i.postimg.cc/50XScH0F/J3-3.jpg",
      item_img_3:
        "https://i.postimg.cc/nzNYnHjS/J3-4.jpg",
      item_img_4:
        "https://i.postimg.cc/0jmGQL7k/J3-5.jpg",
      price: 612,
      old_price: "₹1699",
      price_off: "63% Off",
      category: "Jeans",
      rating: 3.5,
      // qty: 1,
    },
    {
      id: 34,
      brand: "Shopster",
      name: "Men Regular Fit Dark Blue Cotton Blend Trousers",
      main_img:
        "https://i.postimg.cc/3wSFbjKT/J4-1.jpg",
      item_img_1:
        "https://i.postimg.cc/mZFy8FJv/J4-2.jpg",
      item_img_2:
        "https://i.postimg.cc/x1gvcGNz/J4-3.jpg",
      item_img_3:
        "https://i.postimg.cc/6QgGvMWy/J4-4.jpg",
      item_img_4:
        "https://i.postimg.cc/cCMKPZQn/J4-5.jpg",
      price: 394,
      old_price: "₹1299",
      price_off: "69% Off",
      category: "Trousers",
      rating: 3.8,
      // qty: 1,

    },
    {
      id: 35,
      brand: "Shopster",
      name: "Men Cargos",
      main_img:
        "https://i.postimg.cc/pLqW9CQz/J5-1.jpg",
      item_img_1:
        "https://i.postimg.cc/g0jY3h45/J5-2.jpg",
      item_img_2:
        "https://i.postimg.cc/sXZsNRk4/J5-3.jpg",
      item_img_3:
        "https://i.postimg.cc/P5tfr9Dd/J5-4.jpg",
      item_img_4:
        "https://i.postimg.cc/XvPnLvzv/J5-5.jpg",
      price: 649,
      old_price: "₹2829",
      price_off: "77% Off",
      category: "Cargos",
      rating: 0,
      // qty: 1,
    },
  ],

  MensBlazerData : [
    {
      id: 91,
      brand: "Shopster",
      name: "Men Self Design Single Breasted Casual Blazer",
      main_img:
        "https://i.postimg.cc/vHLhVqPP/B1-1.jpg",
      item_img_1:
        "https://i.postimg.cc/htDrbL6K/B1-2.jpg",
      item_img_2:
        "https://i.postimg.cc/qv1GmtHy/B1-3.jpg",
      item_img_3:
        "https://i.postimg.cc/BvtBRqJy/B1-4.jpg",
      item_img_4:
        "https://i.postimg.cc/Kj7Ptj5K/B1-5.jpg",
      price: 3523,
      old_price: "₹6999",
      price_off: "49% Off",
      category: "Blazer",
      rating: 4.6,
      // qty: 1,

    },
    {
      id: 92,
      brand: "Shopster",
      name: "Men Checkered Single Breasted Casual Blazer",
      main_img:
        "https://i.postimg.cc/LX1B6NY3/B2-1.jpg",
      item_img_1:
        "https://i.postimg.cc/QxbgtBtw/B2-2.jpg",
      item_img_2:
        "https://i.postimg.cc/7Ztg3pSN/B2-3.jpg",
      item_img_3:
        "https://i.postimg.cc/nL5GJ6zL/B2-4.jpg",
      item_img_4:
        "https://i.postimg.cc/fb3YBBKQ/B2-5.jpg",
      price: 3330,
      old_price: "₹8999",
      price_off: "62% Off",
      category: "Blazer",
      rating: 3.5,
      // qty: 1,
    },
    {
      id: 93,
      brand: "Shopster",
      name: "Men Solid Bandhgala Formal Blazer",
      main_img:
        "https://i.postimg.cc/Y2LyhxKV/B3-1.jpg",
      item_img_1:
        "https://i.postimg.cc/NjDdWJmy/B3-2.jpg",
      item_img_2:
        "https://i.postimg.cc/LXcDzrKW/B3-3.jpg",
      item_img_3:
        "https://i.postimg.cc/13sW7hnh/B3-4.jpg",
      item_img_4:
        "https://i.postimg.cc/CKKcYGsc/B3-5.jpg",
      price: 6764,
      old_price: "₹8999",
      price_off: "24% Off",
      category: "Blazer",
      rating: 3.5,
      // qty: 1,
    },
    {
      id: 94,
      brand: "Shopster",
      name: "Men Solid Single Breasted Casual Blazer",
      main_img:
        "https://i.postimg.cc/Wz0nSXs1/B4-1.jpg",
      item_img_1:
        "https://i.postimg.cc/jdzghdj4/B4-2.jpg",
      item_img_2:
        "https://i.postimg.cc/d1knZJXd/B4-3.jpg",
      item_img_3:
        "https://i.postimg.cc/HWMBpsb1/B4-4.jpg",
      item_img_4:
        "https://i.postimg.cc/90HP4Zy5/B4-5.jpg",
      price: 3020,
      old_price: "₹5999",
      price_off: "49% Off",
      category: "Blazer",
      rating: 4.1,
      // qty: 1,

    },
    {
      id: 95,
      brand: "Shopster",
      name: "Men Checkered Single Breasted Casual Blazer",
      main_img:
        "https://i.postimg.cc/fWYjGqhw/B5.jpg",
      item_img_1:
        "https://i.postimg.cc/LsrL7LCY/B5-1.jpg",
      item_img_2:
        "https://i.postimg.cc/0jvm5xq9/B5-2.jpg",
      item_img_3:
        "https://i.postimg.cc/Y0xFhVpY/B5-4.jpg",
      item_img_4:
        "https://i.postimg.cc/hjTTqv6C/B5-5.jpg",
      price: 3330,
      old_price: "₹8999",
      price_off: "62% Off",
      category: "Blazer",
      rating: 0,
      // qty: 1,
    },
  ],

}

export default MensWear;